module.exports = __webpack_public_path__ + "img/mv2.889b8205.png";